import { render, staticRenderFns } from "./waveform.vue?vue&type=template&id=6c283225&"
import script from "./waveform.vue?vue&type=script&lang=js&"
export * from "./waveform.vue?vue&type=script&lang=js&"
import style0 from "./waveform.vue?vue&type=style&index=0&id=6c283225&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports